// Generated by purs version 0.15.16
import * as API_Document from "../API.Document/index.js";
import * as App_Operation_Types from "../App.Operation.Types/index.js";
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Boolean from "../Data.Boolean/index.js";
import * as Data_Either from "../Data.Either/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Semiring from "../Data.Semiring/index.js";
import * as GraphQL_Type from "../GraphQL.Type/index.js";
import * as Steps_Step3_Editability from "../Steps.Step3.Editability/index.js";
import * as Steps_Step3_Transition from "../Steps.Step3.Transition/index.js";
import * as Steps_WorkQueue_Cache from "../Steps.WorkQueue.Cache/index.js";
import * as Steps_WorkQueue_View from "../Steps.WorkQueue.View/index.js";
import * as Widgets_Form_Class from "../Widgets.Form.Class/index.js";
var eq = /* #__PURE__ */ Data_Eq.eq(/* #__PURE__ */ GraphQL_Type.eqRNTY(Data_Eq.eqString));
var map = /* #__PURE__ */ Data_Functor.map(Data_Functor.functorArray);
var length = /* #__PURE__ */ Data_Foldable.length(Data_Foldable.foldableArray)(Data_Semiring.semiringInt);
var map1 = /* #__PURE__ */ Data_Functor.map(Data_Maybe.functorMaybe);
var CommentCreated = /* #__PURE__ */ (function () {
    function CommentCreated(value0) {
        this.value0 = value0;
    };
    CommentCreated.create = function (value0) {
        return new CommentCreated(value0);
    };
    return CommentCreated;
})();
var CommentUpdated = /* #__PURE__ */ (function () {
    function CommentUpdated(value0) {
        this.value0 = value0;
    };
    CommentUpdated.create = function (value0) {
        return new CommentUpdated(value0);
    };
    return CommentUpdated;
})();
var CommentDeleted = /* #__PURE__ */ (function () {
    function CommentDeleted(value0) {
        this.value0 = value0;
    };
    CommentDeleted.create = function (value0) {
        return new CommentDeleted(value0);
    };
    return CommentDeleted;
})();
var AttachmentCreated = /* #__PURE__ */ (function () {
    function AttachmentCreated(value0) {
        this.value0 = value0;
    };
    AttachmentCreated.create = function (value0) {
        return new AttachmentCreated(value0);
    };
    return AttachmentCreated;
})();
var AttachmentDeleted = /* #__PURE__ */ (function () {
    function AttachmentDeleted(value0) {
        this.value0 = value0;
    };
    AttachmentDeleted.create = function (value0) {
        return new AttachmentDeleted(value0);
    };
    return AttachmentDeleted;
})();
var SignatureSigned = /* #__PURE__ */ (function () {
    function SignatureSigned(value0) {
        this.value0 = value0;
    };
    SignatureSigned.create = function (value0) {
        return new SignatureSigned(value0);
    };
    return SignatureSigned;
})();
var SignatureSignedAndRefreshed = /* #__PURE__ */ (function () {
    function SignatureSignedAndRefreshed(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    SignatureSignedAndRefreshed.create = function (value0) {
        return function (value1) {
            return new SignatureSignedAndRefreshed(value0, value1);
        };
    };
    return SignatureSignedAndRefreshed;
})();
var SignatureGroupRefreshed = /* #__PURE__ */ (function () {
    function SignatureGroupRefreshed(value0) {
        this.value0 = value0;
    };
    SignatureGroupRefreshed.create = function (value0) {
        return new SignatureGroupRefreshed(value0);
    };
    return SignatureGroupRefreshed;
})();
var SignaturesRequested = /* #__PURE__ */ (function () {
    function SignaturesRequested(value0) {
        this.value0 = value0;
    };
    SignaturesRequested.create = function (value0) {
        return new SignaturesRequested(value0);
    };
    return SignaturesRequested;
})();
var CreateComment = /* #__PURE__ */ (function () {
    function CreateComment(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    CreateComment.create = function (value0) {
        return function (value1) {
            return new CreateComment(value0, value1);
        };
    };
    return CreateComment;
})();
var UpdateComment = /* #__PURE__ */ (function () {
    function UpdateComment(value0, value1, value2) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
    };
    UpdateComment.create = function (value0) {
        return function (value1) {
            return function (value2) {
                return new UpdateComment(value0, value1, value2);
            };
        };
    };
    return UpdateComment;
})();
var DeleteComment = /* #__PURE__ */ (function () {
    function DeleteComment(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    DeleteComment.create = function (value0) {
        return function (value1) {
            return new DeleteComment(value0, value1);
        };
    };
    return DeleteComment;
})();
var CreateAttachment = /* #__PURE__ */ (function () {
    function CreateAttachment(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    CreateAttachment.create = function (value0) {
        return function (value1) {
            return new CreateAttachment(value0, value1);
        };
    };
    return CreateAttachment;
})();
var DeleteAttachment = /* #__PURE__ */ (function () {
    function DeleteAttachment(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    DeleteAttachment.create = function (value0) {
        return function (value1) {
            return new DeleteAttachment(value0, value1);
        };
    };
    return DeleteAttachment;
})();
var SignWithCapturedSignature = /* #__PURE__ */ (function () {
    function SignWithCapturedSignature(value0, value1, value2, value3) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
        this.value3 = value3;
    };
    SignWithCapturedSignature.create = function (value0) {
        return function (value1) {
            return function (value2) {
                return function (value3) {
                    return new SignWithCapturedSignature(value0, value1, value2, value3);
                };
            };
        };
    };
    return SignWithCapturedSignature;
})();
var SignWithSavedSignature = /* #__PURE__ */ (function () {
    function SignWithSavedSignature(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    SignWithSavedSignature.create = function (value0) {
        return function (value1) {
            return new SignWithSavedSignature(value0, value1);
        };
    };
    return SignWithSavedSignature;
})();
var RefreshSignatureGroup = /* #__PURE__ */ (function () {
    function RefreshSignatureGroup(value0) {
        this.value0 = value0;
    };
    RefreshSignatureGroup.create = function (value0) {
        return new RefreshSignatureGroup(value0);
    };
    return RefreshSignatureGroup;
})();
var RequestSignatures = /* #__PURE__ */ (function () {
    function RequestSignatures(value0) {
        this.value0 = value0;
    };
    RequestSignatures.create = function (value0) {
        return new RequestSignatures(value0);
    };
    return RequestSignatures;
})();
var JumpIdxF = /* #__PURE__ */ (function () {
    function JumpIdxF(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    JumpIdxF.create = function (value0) {
        return function (value1) {
            return new JumpIdxF(value0, value1);
        };
    };
    return JumpIdxF;
})();
var JumpF = /* #__PURE__ */ (function () {
    function JumpF(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    JumpF.create = function (value0) {
        return function (value1) {
            return new JumpF(value0, value1);
        };
    };
    return JumpF;
})();
var NextF = /* #__PURE__ */ (function () {
    function NextF() {

    };
    NextF.value = new NextF();
    return NextF;
})();
var PrevF = /* #__PURE__ */ (function () {
    function PrevF() {

    };
    PrevF.value = new PrevF();
    return PrevF;
})();
var CancelF = /* #__PURE__ */ (function () {
    function CancelF() {

    };
    CancelF.value = new CancelF();
    return CancelF;
})();
var ExportF = /* #__PURE__ */ (function () {
    function ExportF(value0) {
        this.value0 = value0;
    };
    ExportF.create = function (value0) {
        return new ExportF(value0);
    };
    return ExportF;
})();
var SaveCancelF = /* #__PURE__ */ (function () {
    function SaveCancelF() {

    };
    SaveCancelF.value = new SaveCancelF();
    return SaveCancelF;
})();
var SaveF = /* #__PURE__ */ (function () {
    function SaveF() {

    };
    SaveF.value = new SaveF();
    return SaveF;
})();
var AutofillF = /* #__PURE__ */ (function () {
    function AutofillF() {

    };
    AutofillF.value = new AutofillF();
    return AutofillF;
})();
var ToggleLockF = /* #__PURE__ */ (function () {
    function ToggleLockF() {

    };
    ToggleLockF.value = new ToggleLockF();
    return ToggleLockF;
})();
var StateF = /* #__PURE__ */ (function () {
    function StateF(value0) {
        this.value0 = value0;
    };
    StateF.create = function (value0) {
        return new StateF(value0);
    };
    return StateF;
})();
var WorkQueueMetadataF = /* #__PURE__ */ (function () {
    function WorkQueueMetadataF(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    WorkQueueMetadataF.create = function (value0) {
        return function (value1) {
            return new WorkQueueMetadataF(value0, value1);
        };
    };
    return WorkQueueMetadataF;
})();
var WorkQF = /* #__PURE__ */ (function () {
    function WorkQF(value0) {
        this.value0 = value0;
    };
    WorkQF.create = function (value0) {
        return new WorkQF(value0);
    };
    return WorkQF;
})();
var ActionF = /* #__PURE__ */ (function () {
    function ActionF(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    ActionF.create = function (value0) {
        return function (value1) {
            return new ActionF(value0, value1);
        };
    };
    return ActionF;
})();
var DocumentMutationF = /* #__PURE__ */ (function () {
    function DocumentMutationF(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    DocumentMutationF.create = function (value0) {
        return function (value1) {
            return new DocumentMutationF(value0, value1);
        };
    };
    return DocumentMutationF;
})();
var ScrollF = /* #__PURE__ */ (function () {
    function ScrollF() {

    };
    ScrollF.value = new ScrollF();
    return ScrollF;
})();
var updateTransition = function (state) {
    return function (idx) {
        return function (section) {
            var v = Steps_Step3_Transition.enqueueTransition(state.transitionState)(idx)(section);
            return {
                queue: state.queue,
                position: state.position,
                anchor: state.anchor,
                activeSection: state.activeSection,
                sectionIntent: state.sectionIntent,
                workQueueState: state.workQueueState,
                workQueueUi: state.workQueueUi,
                workQueueCache: state.workQueueCache,
                fillState: state.fillState,
                transitionState: v.value1
            };
        };
    };
};
var toggleLock = function (v) {
    return function (state) {
        var doc = (function () {
            var v1 = API_Document.applyLockPermission(v)(state.fillState.doc);
            return {
                attachments: v1.attachments,
                can: v1.can,
                comments: v1.comments,
                contact: v1.contact,
                courses: v1.courses,
                created_at: v1.created_at,
                employer: v1.employer,
                exports: v1.exports,
                formId: v1.formId,
                formName: v1.formName,
                id: v1.id,
                json: v1.json,
                locked_at: v1.locked_at,
                mutations: v1.mutations,
                position: v1.position,
                semester: v1.semester,
                signature_fields: v1.signature_fields,
                signatures: v1.signatures,
                student: v1.student,
                teacher: v1.teacher,
                updated_at: v1.updated_at,
                verifications: v1.verifications,
                access: v.access
            };
        })();
        var fillState = {
            attachments: state.fillState.attachments,
            comments: state.fillState.comments,
            preview: state.fillState.preview,
            signatures: state.fillState.signatures,
            doc: doc,
            form: {
                fields: state.fillState.form.fields,
                id: state.fillState.form.id,
                label: state.fillState.form.label,
                access: v.access
            }
        };
        var patchEditDoc = function (editDoc) {
            if (eq(editDoc.id)(doc.id)) {
                return API_Document.applyLockPermission(v)(editDoc);
            };
            if (Data_Boolean.otherwise) {
                return editDoc;
            };
            throw new Error("Failed pattern match at Steps.Step3.Types (line 195, column 5 - line 197, column 30): " + [ editDoc.constructor.name ]);
        };
        var workQueueState$prime = Steps_WorkQueue_Cache.insertDocument(doc)(state.workQueueState);
        var workQueueState = {
            currentDoc: workQueueState$prime.currentDoc,
            documents: workQueueState$prime.documents,
            forms: workQueueState$prime.forms,
            semester: workQueueState$prime.semester,
            students: workQueueState$prime.students,
            teacher: workQueueState$prime.teacher,
            editDocs: map(patchEditDoc)(workQueueState$prime.editDocs)
        };
        return {
            queue: state.queue,
            position: state.position,
            anchor: state.anchor,
            activeSection: state.activeSection,
            sectionIntent: state.sectionIntent,
            transitionState: state.transitionState,
            workQueueUi: state.workQueueUi,
            workQueueCache: state.workQueueCache,
            fillState: fillState,
            workQueueState: workQueueState
        };
    };
};
var onLastItem = function (state) {
    return state.position > (length(state.queue) - 2 | 0);
};
var onFirstItem = function (state) {
    return state.position <= 0;
};
var matchesLookup = function (lookup) {
    return function (entry) {
        return eq(entry.student)(lookup.studentId) && (function () {
            if (entry.form instanceof Data_Either.Left && lookup.documentId instanceof Data_Maybe.Just) {
                return eq(entry.form.value0.id)(lookup.documentId.value0);
            };
            if (entry.form instanceof Data_Either.Left && lookup.documentId instanceof Data_Maybe.Nothing) {
                return eq(entry.form.value0.form_type.id)(lookup.formId);
            };
            if (entry.form instanceof Data_Either.Right && lookup.documentId instanceof Data_Maybe.Just) {
                return false;
            };
            if (entry.form instanceof Data_Either.Right && lookup.documentId instanceof Data_Maybe.Nothing) {
                return eq(entry.form.value0)(lookup.formId);
            };
            throw new Error("Failed pattern match at Steps.Step3.Types (line 177, column 42 - line 181, column 57): " + [ entry.form.constructor.name, lookup.documentId.constructor.name ]);
        })();
    };
};
var initialLoadOperationKind = function (v) {
    return function (maybeDoc) {
        return new App_Operation_Types.LoadStep3Document(map1(function (v1) {
            return v1.id;
        })(maybeDoc));
    };
};
var formEditability = function (state) {
    return Steps_Step3_Editability.step3Editability(state.doc.can.lock)(state.doc.locked_at)(state.form);
};
var hasEditableFields = function ($62) {
    return (function (v) {
        return v.hasEditableFields;
    })(formEditability($62));
};
var formContext = function (workQueueCache) {
    return function (state) {
        var v = Widgets_Form_Class.initFormContext(workQueueCache.account)(state.doc);
        return {
            parentIds: v.parentIds,
            curIndex: v.curIndex,
            isAutofilling: v.isAutofilling,
            autofillArgs: v.autofillArgs,
            account: v.account,
            doc: v.doc,
            access: state.form.access
        };
    };
};
var enqueueLookupTransition = function (state) {
    return function (lookup) {
        return function (section) {
            var v = Data_Array.findIndex(matchesLookup(lookup))(state.queue);
            if (v instanceof Data_Maybe.Just) {
                return updateTransition(state)(v.value0)(section);
            };
            if (v instanceof Data_Maybe.Nothing) {
                return state;
            };
            throw new Error("Failed pattern match at Steps.Step3.Types (line 166, column 48 - line 168, column 21): " + [ v.constructor.name ]);
        };
    };
};
var defaultRenderOptions = /* #__PURE__ */ (function () {
    return {
        signatures: true,
        sideAndTopBar: true,
        updateUrl: Data_Maybe.Nothing.value,
        onCancel: Data_Maybe.Nothing.value,
        onFinish: Data_Maybe.Nothing.value
    };
})();
var currentFillEntry = function (state) {
    return Data_Array.index(state.queue)(state.position);
};
var loadOperationKindForState = function (state) {
    var v = currentFillEntry(state);
    if (v instanceof Data_Maybe.Just && v.value0.form instanceof Data_Either.Left) {
        return new App_Operation_Types.LoadStep3Document(new Data_Maybe.Just(v.value0.form.value0.id));
    };
    return new App_Operation_Types.LoadStep3Document(Data_Maybe.Nothing.value);
};
var captureTransitionIntent = function (state) {
    return function (v) {
        if (v instanceof WorkQF && v.value0 instanceof Steps_WorkQueue_View.UIStateChange) {
            return {
                queue: state.queue,
                position: state.position,
                anchor: state.anchor,
                activeSection: state.activeSection,
                sectionIntent: state.sectionIntent,
                transitionState: state.transitionState,
                workQueueState: state.workQueueState,
                workQueueCache: state.workQueueCache,
                fillState: state.fillState,
                workQueueUi: v.value0.value0
            };
        };
        if (v instanceof WorkQF && v.value0 instanceof Steps_WorkQueue_View.JumpToForm) {
            return enqueueLookupTransition(state)(v.value0.value0.lookup)(v.value0.value0.section);
        };
        if (v instanceof JumpF) {
            return enqueueLookupTransition(state)(v.value0)(v.value1);
        };
        if (v instanceof JumpIdxF && (v.value0 >= 0 && v.value0 < length(state.queue))) {
            return updateTransition(state)(v.value0)(v.value1);
        };
        if (v instanceof NextF && !onLastItem(state)) {
            return updateTransition(state)(state.position + 1 | 0)(Data_Maybe.Nothing.value);
        };
        if (v instanceof PrevF && state.position > 0) {
            return updateTransition(state)(state.position - 1 | 0)(Data_Maybe.Nothing.value);
        };
        return state;
    };
};
export {
    JumpIdxF,
    JumpF,
    NextF,
    PrevF,
    CancelF,
    ExportF,
    SaveCancelF,
    SaveF,
    AutofillF,
    ToggleLockF,
    StateF,
    WorkQueueMetadataF,
    WorkQF,
    ActionF,
    DocumentMutationF,
    ScrollF,
    CreateComment,
    UpdateComment,
    DeleteComment,
    CreateAttachment,
    DeleteAttachment,
    SignWithCapturedSignature,
    SignWithSavedSignature,
    RefreshSignatureGroup,
    RequestSignatures,
    CommentCreated,
    CommentUpdated,
    CommentDeleted,
    AttachmentCreated,
    AttachmentDeleted,
    SignatureSigned,
    SignatureSignedAndRefreshed,
    SignatureGroupRefreshed,
    SignaturesRequested,
    defaultRenderOptions,
    onFirstItem,
    onLastItem,
    currentFillEntry,
    initialLoadOperationKind,
    loadOperationKindForState,
    captureTransitionIntent,
    matchesLookup,
    toggleLock,
    formContext,
    formEditability,
    hasEditableFields
};
//# sourceMappingURL=index.js.map
